import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SingleArrowDown, SingleArrowUp } from '@r1-frontend/ui-react/components/svg/arrows';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { usePartialList } from '@r1-frontend/shared/hooks/usePartialList';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import DecoderCardView from '~/src/features/full-buy/containers/DecoderList/DecoderCardsView';
import { getLimits } from '~/src/features/full-buy/helpersForProducts';
import { selectProductsByCategory } from '~/src/features/full-buy/store/selectors/products/selectProductsByCategory';
import { TProduct } from '~/src/features/full-buy/store/transformShopItem';
import { useValueByBreakpoint } from '~/src/helpers/hooks/useValueByBreakpoint';
import { TState } from '~/src/store';

interface IProps {
    openAddEquipmentPopup: (equipment: TProduct, isInstallmentDisabled: boolean) => void,
    handleDecrement: (id: number) => () => void,
    handleIncrement: (id: number) => () => void,
}

export const DecoderCardsViewWithButton = ({
    handleIncrement,
    handleDecrement,
    openAddEquipmentPopup,
}: IProps) => {
    const analytics = useAnalytics();
    const category = EShopCategory.Decoders;
    const equipments = useSelector((state: TState) => selectProductsByCategory(state, category));

    const cardCount = useValueByBreakpoint({
        desktop: 3,
        sDesktop: 2,
    });
    const [partialEquipments, isPartial, setIsPartial] = usePartialList(equipments, cardCount);
    const showMoreText = useMemo(() => isPartial ? 'Показать все тв-приставки' : 'Скрыть тв-приставки', [isPartial]);

    const limits = useMemo(() => getLimits(equipments, category), [equipments, category]);

    const onClickShowAll = () => {
        setIsPartial(!isPartial);
        analytics.equipment.clickShowMore();
    };

    return <>
        <FullWidthListContainer $desktop={16} $mobile={12} $direction={'row'} $wrap={'wrap'}>
            {partialEquipments.map((product) => {
                const { selectedPrice: { duration }, quantity } = product;
                const isInstallmentLimit = !!duration && limits.installment && !!quantity;
                const isDisabled = limits.total || isInstallmentLimit;

                return (
                    <DecoderCardView
                        key={`DecoderEntity_${product.id}`}
                        openAddEquipmentPopup={openAddEquipmentPopup}
                        handleIncrement={handleIncrement}
                        handleDecrement={handleDecrement}
                        isDisabled={isDisabled}
                        product={product}
                    />
                );
            })}
        </FullWidthListContainer>

        {
            equipments.length > cardCount && (
                <ControlElement
                    Icon={isPartial ? SingleArrowDown : SingleArrowUp}
                    onClick={onClickShowAll}
                >
                    {showMoreText}
                </ControlElement>
            )
        }
    </>;
};
